import httpMainApi from './httpMainApi'
import { buildParams } from '../support/util'

const autoCompletePartners = async (parnerName = undefined) => (await httpMainApi.get(`partners/autocomplete/${parnerName}`))

const getPartnerById = async (id) => {
  try {
    const partner =  await httpMainApi.get(`partners/${id}`)
    return partner
  } catch(error){
    console.error(error)
  }
}

const getPartnersCategories = async () => {
  try {
    const { data } =  await httpMainApi.get(`challenges/partners/categories`)
    return data
  }catch(error) {
    console.error(error)
  }
}

const getPartnersByCategory = async (category) => {
  try {
    const { data } = await httpMainApi.get(`challenges/partners${buildParams(category)}`)
    return data
  } catch (error) {
    console.error(error)
  }
}


export {
  autoCompletePartners,
  getPartnerById,
  getPartnersCategories,
  getPartnersByCategory
}